import { ReactElement } from 'react'

import SelectExtratoImpl from 'modules/pagamentos/domain/usecases/SelectExtratoImpl'
import PagamentoRepository from 'modules/pagamentos/infra/repositories/PagamentoRepository'
import Extrato from 'modules/pagamentos/pages/Pagamento'

import ComprovanteTransferenciaImpl from '../domain/usecases/ComprovanteTransferencia'
import GetCartoes from '../domain/usecases/GetCartoes'
import GetPercentualTransferenciaMotoristaImpl from '../domain/usecases/GetPercentualTransferenciaMotorista'
import UpdatePercentualTransferenciaMotoristaImpl from '../domain/usecases/UpdatePercentualTransferenciaMotorista'
import TransferenciaRepository from '../infra/repositories/TransferenciaRepository'
import VerifyPasswordImpl from '../domain/usecases/VerifyPassword'
import ExportarExtratoImpl from '../domain/usecases/ExportarExtrato'
import GerarBoletoDepositoImpl from '../domain/usecases/GerarBoletoDeposito'
import ListaBoletosDepositoImpl from '../domain/usecases/ListaBoletosDeposito'
import BaixarPdfBoletoDepositoImpl from '../domain/usecases/BaixarPdfBoletoDeposito'
import ListaContaEscrowImpl from '../domain/usecases/ListaContaEscrow'

export const PagamentoFactory = (): ReactElement => {
  const pagamentoRepository = new PagamentoRepository()
  const selectExtrato = new SelectExtratoImpl(pagamentoRepository)
  const transferenciaRepository = new TransferenciaRepository()
  const getPercentualTransferenciaMotoristaImpl =
    new GetPercentualTransferenciaMotoristaImpl(pagamentoRepository)
  const updatePercentualTransferenciaMotoristaImpl =
    new UpdatePercentualTransferenciaMotoristaImpl(pagamentoRepository)
  const comprovanteTransferenciaImpl = new ComprovanteTransferenciaImpl(
    transferenciaRepository,
  )
  const exportarExtratoImpl = new ExportarExtratoImpl(pagamentoRepository)
  const getCartao = new GetCartoes(pagamentoRepository)
  const verifyPassword = new VerifyPasswordImpl(pagamentoRepository)
  const gerarBoletoDeposito = new GerarBoletoDepositoImpl(pagamentoRepository)
  const listaBoletosDeposito = new ListaBoletosDepositoImpl(pagamentoRepository)
  const baixarPdfBoletoDeposito = new BaixarPdfBoletoDepositoImpl(
    pagamentoRepository,
  )
  const listaContaEscrow = new ListaContaEscrowImpl(pagamentoRepository)

  return (
    <Extrato
      selectExtrato={selectExtrato}
      updatePercentualTransferenciaMotorista={
        updatePercentualTransferenciaMotoristaImpl
      }
      getPercentualTransferenciaMotorista={
        getPercentualTransferenciaMotoristaImpl
      }
      comprovanteTransferencia={comprovanteTransferenciaImpl}
      getCartao={getCartao}
      verifyPassword={verifyPassword}
      exportarExtrato={exportarExtratoImpl}
      gerarBoletoDeposito={gerarBoletoDeposito}
      listaBoletosDeposito={listaBoletosDeposito}
      baixarPdfBoletoDeposito={baixarPdfBoletoDeposito}
      listaContaEscrow={listaContaEscrow}
    />
  )
}
